// extracted by mini-css-extract-plugin
export default {"login":"login_login__fGXOR","login__logo":"login_login__logo__1qqS-"};